module.exports = __webpack_public_path__ + "img/img62.858acc39.png";